import React, { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { NewShow } from "./components/NewShow";
import { Marquee } from "./components/Marquee";
import { Manifesto } from "./components/Manifesto";
import { Music } from "./components/Music";
import { Concerts } from "./components/Concerts";
import { Live } from "./components/Live";
import { Carteleria } from "./components/Carteleria";
import { Gallery } from "./components/Gallery";
import { Booking } from "./components/Booking";
import { Press } from "./components/Press";
import { Footer } from "./components/Footer";
import { AmbientPlayer } from "./components/AmbientPlayer";

const GRAIN =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.6'/%3E%3C/svg%3E";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }
  static getDerivedStateFromError() {
    return { error: true };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-ink text-cream flex items-center justify-center font-serif text-2xl italic">
          Algo se ha apagado en el escenario. Vuelve a intentarlo en unos segundos.
        </div>
      );
    }
    return this.props.children;
  }
}

const Page = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="relative bg-ink text-cream">
      <Navbar />
      <main>
        <Hero />
        <NewShow />
        <Marquee />
        <Manifesto />
        <Music />
        <Concerts />
        <Live />
        <Carteleria />
        <Gallery />
        <Booking />
        <Press />
      </main>
      <Footer />
      <AmbientPlayer />
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 z-[90] mix-blend-overlay opacity-[0.05]"
        style={{ backgroundImage: `url("${GRAIN}")` }}
      />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1C1916",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#F5F0EB",
            borderRadius: "0px",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <Page />
    </ErrorBoundary>
  );
}

export default App;
